import React from 'react';
export const CTASection = () => {
  return <section id="cta" className="w-full py-16 bg-indigo-600" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-61">
        <h2 className="text-3xl font-bold text-white" data-id="element-62">
          Ready to Transform Your Enterprise?
        </h2>
        <p className="mt-4 text-xl text-indigo-100 max-w-3xl mx-auto" data-id="element-63">
          Join the AI revolution and stay ahead of the competition with our
          comprehensive enterprise AI solution.
        </p>
        <div className="mt-8 flex justify-center" data-id="element-64">
          <a href="mailto:contact@nterprizeai.com" className="bg-white text-indigo-600 px-6 py-3 rounded-md font-medium hover:bg-gray-100 transition-colors inline-block" data-id="element-65">
            Request a Demo
          </a>
        </div>
      </div>
    </section>;
};